<template>
  <div class="page-notice">
    <ComponentTopHeader @onBack="handleBack"></ComponentTopHeader>
    <dv-border-box-2 :color="[$color.borderColor, $color.borderColor]">
      <!-- <div class="pt-4 cursor-pointer" @click="handleBack">
        <dv-decoration-7 style="width: 150px; height: 30px"
          >返回</dv-decoration-7
        >
      </div> -->
      <div
        style="height: calc(100% - 50px)"
        class="flex flex-col justify-center"
      >
        <div class="flex mb-3 justify-between pl-10 pr-10" style="height: 48%">
          <dv-border-box-7
            class="content-box"
            :color="[$color.borderColor, $color.borderColor]"
          >
            <div>
              <div class="cc-header flex justify-around items-center p-0">
                <dv-decoration-1 style="width: 100px; height: 20px" />
                <div class="text-xl font-bold">
                  {{ list[0].name }}
                </div>
                <dv-decoration-1 style="width: 100px; height: 20px" />
              </div>
              <div
                class="rich-text-container"
                v-if="list[0].list && list[0].list.length"
              >
                <el-table
                  :data="list[0].list"
                  style="width: 100%"
                  :show-header="false"
                  @row-click="handleCheckoutItem"
                  row-key="title"
                  height="80%"
                >
                  <el-table-column prop="title" label="" width="">
                  </el-table-column>
                </el-table>
              </div>

              <div class="text-center mt-6">
                <el-pagination
                  :page-size="100"
                  background
                  layout="total, prev, pager, next, jumper"
                  @current-change="handleCurrentChange1"
                  :total="list[0].total"
                >
                </el-pagination>
              </div>
            </div>
          </dv-border-box-7>

          <dv-border-box-7
            v-if="list[1] && list[1].id"
            class="content-box"
            :color="[$color.borderColor, $color.borderColor]"
          >
            <div>
              <div class="cc-header flex justify-around items-center p-0">
                <dv-decoration-1 style="width: 100px; height: 20px" />
                <div class="text-xl font-bold">
                  {{ list[1].name }}
                </div>
                <dv-decoration-1 style="width: 100px; height: 20px" />
              </div>
              <div
                class="rich-text-container"
                v-if="list[1].list && list[1].list.length"
              >
                <el-table
                  :data="list[1].list"
                  style="width: 100%"
                  :show-header="false"
                  height="90%"
                  @row-click="handleCheckoutItem"
                >
                  <el-table-column prop="title" label="" width="">
                  </el-table-column>
                </el-table>
              </div>

              <div class="text-center mt-6">
                <el-pagination
                  :page-size="100"
                  background
                  layout="total, prev, pager, next, jumper"
                  @current-change="handleCurrentChange2"
                  :total="list[1].total"
                >
                </el-pagination>
              </div>
            </div>
          </dv-border-box-7>
        </div>
        <div class="flex pl-10 pr-10 justify-between" style="height: 48%">
          <dv-border-box-7
            v-if="list[2] && list[2].id"
            class="content-box"
            :color="[$color.borderColor, $color.borderColor]"
          >
            <div>
              <div class="cc-header flex justify-around items-center p-0">
                <dv-decoration-1 style="width: 100px; height: 20px" />
                <div class="text-xl font-bold">
                  {{ list[2].name }}
                </div>
                <dv-decoration-1 style="width: 100px; height: 20px" />
              </div>
              <div
                class="rich-text-container"
                v-if="list[2].list && list[2].list.length"
              >
                <el-table
                  :data="list[2].list"
                  style="width: 100%"
                  :show-header="false"
                  height="90%"
                  @row-click="handleCheckoutItem"
                >
                  <el-table-column prop="title" label="" width="">
                  </el-table-column>
                </el-table>
              </div>

              <div class="text-center mt-6">
                <el-pagination
                  :page-size="100"
                  background
                  layout="total, prev, pager, next, jumper"
                  @current-change="handleCurrentChange3"
                  :total="list[2].total"
                >
                </el-pagination>
              </div>
            </div>
          </dv-border-box-7>

          <dv-border-box-7
            v-if="list[3] && list[3].id"
            class="content-box"
            :color="[$color.borderColor, $color.borderColor]"
          >
            <div>
              <div class="cc-header flex justify-around items-center p-0">
                <dv-decoration-1 style="width: 100px; height: 20px" />
                <div class="text-xl font-bold">
                  {{ list[3].name }}
                </div>
                <dv-decoration-1 style="width: 100px; height: 20px" />
              </div>
              <div
                class="rich-text-container"
                v-if="list[3].list && list[3].list.length"
              >
                <el-table
                  :data="list[3].list"
                  style="width: 100%"
                  :show-header="false"
                  @row-click="handleCheckoutItem"
                  height="90%"
                >
                  <el-table-column prop="title" label="" width="">
                  </el-table-column>
                </el-table>
              </div>

              <div class="text-center mt-6">
                <el-pagination
                  :page-size="100"
                  background
                  layout="total, prev, pager, next, jumper"
                  @current-change="handleCurrentChange3"
                  :total="list[3].total"
                >
                </el-pagination>
              </div>
            </div>
          </dv-border-box-7>
        </div>
      </div>
    </dv-border-box-2>
    <NoticeDialog :show.sync="visible" :detail="detail"></NoticeDialog>
  </div>
</template>
<script>
import NoticeDialog from "./Components/NoticeDialog.vue";
import ComponentTopHeader from "../components/datav/TopHeader.vue";
export default {
  data() {
    return {
      list: [
        {
          list: [],
        },
      ],

      visible: false,
      detail: {},
    };
  },
  components: {
    NoticeDialog,
    ComponentTopHeader,
  },
  methods: {
    handleBack() {
      this.$router.back();
    },
    getList() {
      this.$axios
        .get("/articleService/open/module/paginate")
        .then(async (resp) => {
          let list = resp.data.list;
          if (list.length > 4) {
            list = list.slice(0, 4);
          }
          for (let i = 0; i < list.length; i++) {
            let response = await this.getArticleList({
              moduleId: list[i].id,
            });
            list[i].list = response.list;
            list[i].query = {
              page: 1,
            };
            list[i].total = response.total;
          }
          this.list = list;
          console.log("list", this.list);
        });
    },
    getArticleList(params) {
      return new Promise((resolve) => {
        this.$axios
          .get("/articleService/open/article/paginate", {
            params,
          })
          .then((resp) => {
            resolve(resp.data);
          });
      });
    },
    handleCheckoutItem(row) {
      console.log(row);
      this.handleDetail(row.id);
    },
    handleDetail(id) {
      this.$axios
        .get("/articleService/open/article", {
          params: {
            id,
            mechanismId: "M57wVRNZ",
          },
        })
        .then((resp) => {
          this.detail = resp.data;
          this.visible = true;
        });
    },
    handleCurrentChange1(page) {
      let query = this.list[0].query;
      query.page = page;
      let response = this.getArticleList(query);
      this.list[0].list = response.list;
    },

    handleCurrentChange2(page) {
      let query = this.list[1].query;
      query.page = page;
      let response = this.getArticleList(query);
      this.list[1].list = response.list;
    },

    handleCurrentChange3(page) {
      let query = this.list[2].query;
      query.page = page;
      let response = this.getArticleList(query);
      this.list[2].list = response.list;
    },

    handleCurrentChange4(page) {
      let query = this.list[3].query;
      query.page = page;
      let response = this.getArticleList(query);
      this.list[3].list = response.list;
    },
  },
  mounted() {
    this.getList();
  },
};
</script>
<style scoped lang="less">
.page-notice {
  height: 100%;
  width: 1920px;
}
.cc-header {
  min-width: 300px;
  margin: 14px auto;
  display: flex;
  justify-content: center;
}
.content-box {
  height: 90%;
  width: 49%;
  margin-bottom: 40px;
}
.rich-text-container {
  height: 320px;
}
::v-deep {
  .el-pagination {
    color: #fff;
  }
  .el-pagination__total,
  .el-pagination__jump {
    color: #fff;
  }
  .el-table::before {
    height: 0;
  }
  .el-table,
  .el-table__body {
    background: transparent !important;
    color: #fff;
    border: none;
  }

  .el-table th {
    background-color: transparent !important;
  }
  .el-table tr {
    background-color: transparent !important;
  }
  .el-table__body tr.hover-row > td {
    background-color: #a5ccf2 !important;
    border: none;
  }
  .el-table tbody tr:hover > td {
    border: 1px solid #abd1e7;

    background-color: #17468d !important //修改成自己想要的颜色即可
;
  }
}
</style>
